import * as Sentry from '@sentry/nextjs';
import { captureException } from '@willbooster-private/kaizen-spring/browser';

/** Reports an error caught by a client-side error boundary to every error-tracking service. */
export function reportClientError(error: unknown, userId?: string): void {
  Sentry.captureException(error, userId ? { user: { id: userId } } : undefined);
  void captureException(error, { userId });
}
